// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","rightSectionWrapper":"App_rightSectionWrapper__pdzps"};